const INTERNAL_TELEMETRY_PATHS = new Set([
  "/api/dev/frontend-logs",
  "/api/observability/client",
]);

/** Telemetry delivery must not generate telemetry about its own requests. */
export function isInternalTelemetryPath(pathname: string): boolean {
  return INTERNAL_TELEMETRY_PATHS.has(pathname);
}
